import React, { useState, useEffect } from "react";
import KhataList from "./KhataList";
import Khata from "views/Khata";
import NoKhata from "views/NoKhata";
import useUniversalStore from "store/universalStore";
import Onboarding from "views/Onboarding";
import { Loader } from "components";

const index = () => {
  const { accountId, accounts, fetchInitialData } = useUniversalStore((state) => state);

  useEffect(() => {
    if (!accounts) {
      fetchInitialData();
    }

  }, []);

  return (
    <div className="container-fluid px-0 h-100">
      <div className="row g-0 h-100">
        <div className={`col-12 col-md-4 px-0 mx-0 border-end ${accountId ? 'd-none d-md-block' : ''}`}>
          <KhataList />
        </div>
        <div className={`col-12 col-md-8 px-0 mx-0  ${!accountId ? 'd-none d-md-block' : ''}`}>
          {accountId ? <Khata /> : <NoKhata />}
        </div>
      </div>
    </div>
  )
}

export default index;